export const OID = {
  /** rsaEncryption — used in PKCS#8 AlgorithmIdentifier */
  RSA_ENCRYPTION: '1.2.840.113549.1.1.1',
} as const;
